import { makeStyles } from "@material-ui/core"

export const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        minHeight: '70%',
        // marginBottom: theme.spacing(4)
    },
    pdfButton: {
        display: 'flex',
        margin: '0 auto 20px'
    },
    title: {
        marginBottom: theme.spacing(1),
        fontWeight: 'bold',
        background: 'transparent',
        border: 'none',
        boxShadow: 'none',
    },
    listContainer: {
        width: '80%',
        marginRight: '40px'
    },
    listContainerLast: {
        marginRight: 0
    },
    cardsContainer: {
        height: '400px',
        overflow: 'auto',
        paddingRight: theme.spacing(2)
    },
    emptyCard: {
        backgroundColor: 'transparent',
        border: 'none',
        boxShadow: 'none'
    },
    emptyCardSm: {
        height: '50px',
    },
    emptyCardLg: {
        height: '200px',
    }
}))